export default __webpack_public_path__ + "static/media/67.8e19aa43.jpeg";